import { render, staticRenderFns } from "./payrollitem.vue?vue&type=template&id=69681504&scoped=true"
import script from "./payrollitem.vue?vue&type=script&lang=js"
export * from "./payrollitem.vue?vue&type=script&lang=js"
import style0 from "./payrollitem.vue?vue&type=style&index=0&id=69681504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69681504",
  null
  
)

export default component.exports